module.exports = __webpack_public_path__ + "img/numeric_pain.6a070819.png";